import Role from 'types/entities/Role';
import { SearchParams } from 'api/ResourceAPI';
import Order from 'types/entities/Order';
import { CatalogWorkunit } from 'types/entities/CatalogWorkunit';
import { Month } from 'types/models/Months';
import { Quarters } from 'types/models/Quarters';
import { GridRowId, GridSelectionModel, GridSortModel } from '@mui/x-data-grid-pro';
import OrderWorkunit from 'types/entities/OrderWorkunit';
import User from 'types/entities/User';

export interface ChangeBaselineState {
  baseLineOrder: Order | null;
  sourceOrder: Order | null;
  editOrder?: Order | null;
  workunits: CatalogWorkunit[];
  months: Month[];
  quarters: Quarters[];
  changeBaselineData: string[];
  engagementParameters: string[];
  searchParams: SearchParams | null;
  roles: Role[] | null;
  sortBLtotalWorkunitModel: GridSortModel;
  selectedBLDeliverablesList: OrderWorkunit[];
  filterTotalWorkunitData: OrderWorkunit[];
  totalworkunitData: OrderWorkunit[];
  customers: User[];
  deliveryManagers: User[];
  totalItems: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  filterTotalFlag: boolean;
  selectedBLDeliverablesModel: GridSelectionModel;
  selectedBLAllDeliverables: boolean;
  excludedBLDeliverables: GridRowId[];
  baseline_version: number;
  tagFilter: any;
  singleWorkunitSave: boolean;
  multipleWorkunitSave: boolean;
}

export const changeBaselineState: ChangeBaselineState = {
  baseLineOrder: null,
  sourceOrder: null,
  editOrder: null,
  workunits: [],
  months: [],
  quarters: [],
  changeBaselineData: [],
  engagementParameters: [],
  searchParams: {
    // join: ['title', 'description', 'category'],
    size: 50,
    page: 0,
  },
  roles: [],
  sortBLtotalWorkunitModel: [],
  selectedBLDeliverablesList: [],
  filterTotalWorkunitData: [],
  totalworkunitData: [],
  customers: [],
  deliveryManagers: [],
  totalItems: 0,
  totalPages: 0,
  currentPage: 0,
  pageSize: 50,
  filterTotalFlag: false,
  selectedBLDeliverablesModel: [],
  selectedBLAllDeliverables: false,
  excludedBLDeliverables: [],
  baseline_version: 0,
  tagFilter: [],
  singleWorkunitSave: false,
  multipleWorkunitSave: false,
};
